import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "wrapper bg-light" }
const _hoisted_2 = { class: "font-weight-bold mb-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "card-header bg-accent kontact" }
const _hoisted_7 = { class: "card-title" }
const _hoisted_8 = {
  class: "text-body d-flex flex-row align-items-center justify-content-between",
  href: "#collapse-icon-number",
  "data-toggle": "collapse"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row align-items-center text-white" }, " Kontaktnummer ", -1)
const _hoisted_10 = { class: "d-flex flex-row align-items-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "icon-circle-down2 text-white" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  class: "collapse show",
  id: "collapse-icon-number"
}
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = { class: "card" }
const _hoisted_16 = { class: "card-header bg-white" }
const _hoisted_17 = { class: "card-title" }
const _hoisted_18 = {
  class: "text-body d-flex flex-row align-items-center justify-content-between",
  href: "#collapse-icon-general",
  "data-toggle": "collapse"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "" }, " Stammdaten ", -1)
const _hoisted_20 = { class: "d-flex flex-row align-items-center" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "icon-circle-down2" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "text-muted" }
const _hoisted_24 = { class: "d-flex flex-row mt-2 flex-wrap flex-gap-1" }
const _hoisted_25 = {
  class: "collapse show",
  id: "collapse-icon-general"
}
const _hoisted_26 = { class: "card-body" }
const _hoisted_27 = { class: "form-group row" }
const _hoisted_28 = { class: "col-lg-3 col-form-label" }
const _hoisted_29 = { class: "col-lg-9" }
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "form-group row" }
const _hoisted_32 = { class: "col-lg-3 col-form-label" }
const _hoisted_33 = { class: "col-lg-9" }
const _hoisted_34 = ["placeholder"]
const _hoisted_35 = { class: "form-group row" }
const _hoisted_36 = { class: "col-lg-3 col-form-label" }
const _hoisted_37 = { class: "col-lg-9" }
const _hoisted_38 = ["placeholder"]
const _hoisted_39 = { class: "form-group row" }
const _hoisted_40 = { class: "col-lg-3 col-form-label" }
const _hoisted_41 = { class: "col-lg-9" }
const _hoisted_42 = ["placeholder"]
const _hoisted_43 = { class: "form-group row" }
const _hoisted_44 = { class: "col-lg-3 col-form-label" }
const _hoisted_45 = { class: "col-lg-9" }
const _hoisted_46 = { class: "input-group" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text bg-secondary" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon-warning2" })
  ])
], -1)
const _hoisted_48 = ["placeholder"]
const _hoisted_49 = { class: "input-group-append" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("i", { class: "icon-reset" }, null, -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block ml-2" }, "Erneut einladen", -1)
const _hoisted_52 = [
  _hoisted_50,
  _hoisted_51
]
const _hoisted_53 = /*#__PURE__*/_createElementVNode("small", { class: "text-muted" }, [
  /*#__PURE__*/_createElementVNode("b", null, "! An diese E-Mailadresse wird der Registrierungslink gesendet.")
], -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"5px","color":"red","font-weight":"bold"} }, "*"),
  /*#__PURE__*/_createTextVNode("Wenn Sie abweichend von dieser E-Mail eine andere Adresse für den Rechnungsversand hinterlegen möchten, schreiben Sie bitte direkt an "),
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:info@zukos.de" }, "info@zukos.de")
], -1)
const _hoisted_55 = { class: "form-group row" }
const _hoisted_56 = { class: "col-lg-3 col-form-label" }
const _hoisted_57 = { class: "col-lg-9" }
const _hoisted_58 = { class: "input-group" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "----", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Inaktiv", -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Aktiv", -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Gesperrt", -1)
const _hoisted_63 = [
  _hoisted_59,
  _hoisted_60,
  _hoisted_61,
  _hoisted_62
]
const _hoisted_64 = /*#__PURE__*/_createElementVNode("small", { class: "text-muted" }, " Achtung, wenn der Benutzer gesperrt oder deaktiviert wird, wird er aus allen Interventionen und als Projektansprechpartner gelöscht. Bitte überprüfen Sie die Menüpunkt Interventionen und Ansprechpartner. ", -1)
const _hoisted_65 = { class: "row" }
const _hoisted_66 = { class: "col-12 text-right" }
const _hoisted_67 = ["disabled"]
const _hoisted_68 = { class: "card" }
const _hoisted_69 = { class: "card-header bg-white interventionen" }
const _hoisted_70 = { class: "card-title" }
const _hoisted_71 = {
  class: "text-body d-flex flex-row align-items-center justify-content-between",
  href: "#collapse-interventionen",
  "data-toggle": "collapse"
}
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row align-items-center" }, " Interventionen ", -1)
const _hoisted_73 = { class: "d-flex flex-row align-items-center" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("i", { class: "icon-circle-down2" }, null, -1)
const _hoisted_75 = [
  _hoisted_74
]
const _hoisted_76 = {
  class: "collapse",
  id: "collapse-interventionen"
}
const _hoisted_77 = { class: "card-body" }
const _hoisted_78 = {
  key: 0,
  class: "d-block mt-2"
}
const _hoisted_79 = ["onClick"]
const _hoisted_80 = {
  key: 1,
  class: "d-block mt-2"
}
const _hoisted_81 = ["onClick"]
const _hoisted_82 = { class: "card" }
const _hoisted_83 = { class: "card-header bg-white projektansprechpartner" }
const _hoisted_84 = { class: "card-title" }
const _hoisted_85 = {
  class: "text-body d-flex flex-row align-items-center justify-content-between",
  href: "#collapse-projektansprechpartner",
  "data-toggle": "collapse"
}
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row align-items-center" }, " Ansprechpartner ", -1)
const _hoisted_87 = { class: "d-flex flex-row align-items-center" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("i", { class: "icon-circle-down2" }, null, -1)
const _hoisted_89 = [
  _hoisted_88
]
const _hoisted_90 = {
  class: "collapse",
  id: "collapse-projektansprechpartner"
}
const _hoisted_91 = { class: "card-body" }
const _hoisted_92 = {
  key: 0,
  class: "d-block mt-2"
}
const _hoisted_93 = ["onClick"]
const _hoisted_94 = { class: "card" }
const _hoisted_95 = { class: "card-header bg-white" }
const _hoisted_96 = { class: "card-title" }
const _hoisted_97 = {
  class: "text-body collapsed d-flex flex-row align-items-center justify-content-between",
  href: "#collapse-icon-extended",
  "data-toggle": "collapse"
}
const _hoisted_98 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row align-items-center" }, " Erweiterte Stammdaten ", -1)
const _hoisted_99 = { class: "d-flex flex-row align-items-center" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("i", { class: "icon-circle-down2" }, null, -1)
const _hoisted_101 = [
  _hoisted_100
]
const _hoisted_102 = { class: "text-muted d-flex flex-column" }
const _hoisted_103 = {
  class: "collapse",
  id: "collapse-icon-extended"
}
const _hoisted_104 = { class: "card-body" }
const _hoisted_105 = { class: "form-group row" }
const _hoisted_106 = { class: "col-lg-3 col-form-label" }
const _hoisted_107 = { class: "col-lg-9" }
const _hoisted_108 = ["placeholder"]
const _hoisted_109 = { class: "form-group row" }
const _hoisted_110 = { class: "col-lg-3 col-form-label" }
const _hoisted_111 = { class: "col-lg-9" }
const _hoisted_112 = ["placeholder"]
const _hoisted_113 = { class: "form-group row" }
const _hoisted_114 = { class: "col-lg-3 col-form-label" }
const _hoisted_115 = { class: "col-lg-9" }
const _hoisted_116 = ["placeholder"]
const _hoisted_117 = { class: "form-group row" }
const _hoisted_118 = { class: "col-lg-3 col-form-label" }
const _hoisted_119 = { class: "col-lg-9" }
const _hoisted_120 = ["placeholder"]
const _hoisted_121 = { class: "form-group row" }
const _hoisted_122 = { class: "col-md-3 col-form-label" }
const _hoisted_123 = { class: "col-md-9" }
const _hoisted_124 = ["value"]
const _hoisted_125 = { class: "row" }
const _hoisted_126 = { class: "col-12 text-right" }
const _hoisted_127 = ["disabled"]
const _hoisted_128 = { class: "card" }
const _hoisted_129 = { class: "card-header bg-white" }
const _hoisted_130 = { class: "card-title" }
const _hoisted_131 = {
  class: "text-body collapsed d-flex flex-row align-items-center justify-content-between",
  href: "#collapse-icon-rights",
  "data-toggle": "collapse"
}
const _hoisted_132 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row align-items-center" }, " Rechte ", -1)
const _hoisted_133 = { class: "d-flex flex-row align-items-center" }
const _hoisted_134 = /*#__PURE__*/_createElementVNode("i", { class: "icon-circle-down2" }, null, -1)
const _hoisted_135 = [
  _hoisted_134
]
const _hoisted_136 = {
  class: "collapse",
  id: "collapse-icon-rights"
}
const _hoisted_137 = { class: "card-body" }
const _hoisted_138 = { class: "table-responsive" }
const _hoisted_139 = { class: "table" }
const _hoisted_140 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "w-100 font-weight-bold" }, "Recht"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-weight-bold" }, "Aktiv")
  ])
], -1)
const _hoisted_141 = /*#__PURE__*/_createElementVNode("td", null, " Anlagen schalten ", -1)
const _hoisted_142 = { class: "custom-control custom-switch custom-control-dark" }
const _hoisted_143 = ["checked", "disabled"]
const _hoisted_144 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "slc_arming_read"
}, null, -1)
const _hoisted_145 = /*#__PURE__*/_createElementVNode("td", null, " Firmendaten / Ansprechpartner ändern ", -1)
const _hoisted_146 = { class: "custom-control custom-switch custom-control-dark" }
const _hoisted_147 = ["checked", "disabled"]
const _hoisted_148 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "slc_company_read"
}, null, -1)
const _hoisted_149 = /*#__PURE__*/_createElementVNode("td", null, " Benutzer anzeigen ", -1)
const _hoisted_150 = { class: "custom-control custom-switch custom-control-dark" }
const _hoisted_151 = ["checked", "disabled"]
const _hoisted_152 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "slc_user_read"
}, null, -1)
const _hoisted_153 = /*#__PURE__*/_createElementVNode("td", null, " Benutzer anlegen / bearbeiten ", -1)
const _hoisted_154 = { class: "custom-control custom-switch custom-control-dark" }
const _hoisted_155 = ["checked", "disabled"]
const _hoisted_156 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "slc_user_write"
}, null, -1)
const _hoisted_157 = /*#__PURE__*/_createElementVNode("td", null, " Rechnung ", -1)
const _hoisted_158 = { class: "custom-control custom-switch custom-control-dark" }
const _hoisted_159 = ["checked", "disabled"]
const _hoisted_160 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "slc_bill_read"
}, null, -1)
const _hoisted_161 = /*#__PURE__*/_createElementVNode("td", null, " Verträge ", -1)
const _hoisted_162 = { class: "custom-control custom-switch custom-control-dark" }
const _hoisted_163 = ["checked", "disabled"]
const _hoisted_164 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "slc_contracts_read"
}, null, -1)
const _hoisted_165 = /*#__PURE__*/_createElementVNode("td", null, " Intervention und Objektkennwort ", -1)
const _hoisted_166 = { class: "custom-control custom-switch custom-control-dark" }
const _hoisted_167 = ["checked", "disabled"]
const _hoisted_168 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "slc_interventions_write"
}, null, -1)
const _hoisted_169 = { class: "row mt-3" }
const _hoisted_170 = { class: "col-12 text-right" }
const _hoisted_171 = ["disabled"]
const _hoisted_172 = { class: "card" }
const _hoisted_173 = { class: "card-header bg-white" }
const _hoisted_174 = { class: "card-title" }
const _hoisted_175 = {
  class: "text-body collapsed d-flex flex-row align-items-center justify-content-between",
  href: "#collapse-icon-projects",
  "data-toggle": "collapse"
}
const _hoisted_176 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row align-items-center" }, " Projektberechtigung ", -1)
const _hoisted_177 = { class: "d-flex flex-row align-items-center" }
const _hoisted_178 = /*#__PURE__*/_createElementVNode("i", { class: "icon-circle-down2" }, null, -1)
const _hoisted_179 = [
  _hoisted_178
]
const _hoisted_180 = {
  class: "collapse",
  id: "collapse-icon-projects"
}
const _hoisted_181 = { class: "card-body" }
const _hoisted_182 = { class: "table-responsive" }
const _hoisted_183 = {
  cellspacing: "2",
  cellpadding: "0",
  border: "0",
  class: "table"
}
const _hoisted_184 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "d-none d-md-table-cell font-weight-bold" }, "ProjektId"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-nowrap font-weight-bold" }, "Projekt Name"),
    /*#__PURE__*/_createElementVNode("th", { class: "d-none d-md-table-cell w-100 font-weight-bold" }, "Projekt Anschrift"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-weight-bold" }, "Aktion")
  ])
], -1)
const _hoisted_185 = { id: "" }
const _hoisted_186 = { class: "d-none d-md-table-cell" }
const _hoisted_187 = { class: "d-none d-md-table-cell" }
const _hoisted_188 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_189 = { class: "custom-control custom-switch custom-control-dark" }
const _hoisted_190 = ["id", "checked", "disabled", "onChange"]
const _hoisted_191 = ["for"]
const _hoisted_192 = { class: "row mt-3" }
const _hoisted_193 = { class: "col-12 text-right" }
const _hoisted_194 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EditInterventionNumber = _resolveComponent("EditInterventionNumber")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.headline), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h6", _hoisted_7, [
              _createElementVNode("a", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("a", {
                    href: "",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
                    class: "text-body",
                    "data-toggle": "collapse",
                    "aria-expanded": "false"
                  }, _hoisted_12)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_EditInterventionNumber, {
                "user-id": _ctx.userId,
                onSuccess: _ctx.onPhoneSuccess
              }, null, 8, ["user-id", "onSuccess"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("h6", _hoisted_17, [
              _createElementVNode("a", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("a", {
                    href: "",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                    class: "text-body",
                    "data-toggle": "collapse",
                    "aria-expanded": "false"
                  }, _hoisted_22)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.user.firstName.value) + " " + _toDisplayString(_ctx.user.lastName.value) + " ( " + _toDisplayString(_ctx.user.email.value.substr(0, 15) + ' ...') + " ) ", 1),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("span", {
                class: _normalizeClass(["badge badge-pill", 'bg-'+_ctx.userStatus[_ctx.user.status.value].class])
              }, _toDisplayString(_ctx.userStatus[_ctx.user.status.value].name), 3),
              _createElementVNode("span", {
                class: _normalizeClass(["badge badge-pill", _ctx.user.verified.value == 1 ? 'bg-primary': 'bg-secondary'])
              }, _toDisplayString(_ctx.user.verified.value == 1 ? 'Verfiziert': 'Nicht Verifiziert'), 3),
              _createElementVNode("span", {
                class: _normalizeClass(["badge badge-pill", _ctx.user.invitation.value == 1 ? 'bg-primary': 'bg-secondary'])
              }, _toDisplayString(_ctx.user.invitation.value == 1 ? 'Einladung angenommen': 'Einladung nicht angenommen'), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.user.id.name), 1),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("input", {
                    class: "form-control",
                    type: "text",
                    readonly: "readonly",
                    value: _ctx.user.id.value
                  }, null, 8, _hoisted_30)
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.user.firstName.name), 1),
                _createElementVNode("div", _hoisted_33, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    required: "",
                    placeholder: _ctx.user.firstName.name,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.firstName.value) = $event))
                  }, null, 8, _hoisted_34), [
                    [_vModelText, _ctx.user.firstName.value]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.user.lastName.name), 1),
                _createElementVNode("div", _hoisted_37, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    required: "",
                    placeholder: _ctx.user.lastName.name,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.lastName.value) = $event))
                  }, null, 8, _hoisted_38), [
                    [_vModelText, _ctx.user.lastName.value]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.user.jobTitle.name), 1),
                _createElementVNode("div", _hoisted_41, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    required: "",
                    placeholder: _ctx.user.jobTitle.name,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.jobTitle.value) = $event))
                  }, null, 8, _hoisted_42), [
                    [_vModelText, _ctx.user.jobTitle.value]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.user.email.name), 1),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      required: "",
                      placeholder: _ctx.user.email.name,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.user.email.value) = $event))
                    }, null, 8, _hoisted_48), [
                      [_vModelText, _ctx.user.email.value]
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-accent d-flex flex-row align-items-center",
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.reInvite && _ctx.reInvite(...args)))
                      }, _hoisted_52)
                    ])
                  ]),
                  _hoisted_53,
                  _hoisted_54
                ])
              ]),
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.user.status.name), 1),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.user.status.value) = $event))
                    }, _hoisted_63, 512), [
                      [_vModelSelect, _ctx.user.status.value]
                    ])
                  ]),
                  _hoisted_64
                ])
              ]),
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.saveEmployee && _ctx.saveEmployee(...args))),
                    disabled: !_ctx.userRights.user?.write
                  }, "Stammdaten speichern", 8, _hoisted_67)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_68, [
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("h6", _hoisted_70, [
              _createElementVNode("a", _hoisted_71, [
                _hoisted_72,
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("a", {
                    href: "",
                    onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"])),
                    class: "text-body",
                    "data-toggle": "collapse",
                    "aria-expanded": "false"
                  }, _hoisted_75)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_76, [
            _createElementVNode("div", _hoisted_77, [
              (_ctx.getInterventionsAndContactsByUserId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getInterventionsAndContactsByUserId, (interventionsContactsByProject, projectId) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: projectId }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(interventionsContactsByProject.systems, (systems, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(systems.interventionTypes, (intAndContacts, intId) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: intId,
                                class: "badge badge-pill bg-primary mr-1 mb-1 cursor-pointer",
                                onClick: ($event: any) => (_ctx.navigateToSustemIntervention(projectId, index, intId))
                              }, _toDisplayString(_ctx.getInterventionName(interventionsContactsByProject, intAndContacts, projectId)), 9, _hoisted_79))
                            }), 128))
                          ], 64))
                        }), 128))
                      ], 64))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.getInterventionsAndContactsByUserId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getInterventionsAndContactsByUserId, (interventionsContactsByProject, projectId) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: projectId,
                        class: "badge badge-pill bg-secondary mr-1 mb-1 cursor-pointer",
                        onClick: ($event: any) => (_ctx.navigateToSustemIntervention(projectId, _ctx.index, _ctx.intId))
                      }, _toDisplayString(_ctx.isUserAContactInObject(interventionsContactsByProject)), 9, _hoisted_81))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_82, [
          _createElementVNode("div", _hoisted_83, [
            _createElementVNode("h6", _hoisted_84, [
              _createElementVNode("a", _hoisted_85, [
                _hoisted_86,
                _createElementVNode("div", _hoisted_87, [
                  _createElementVNode("a", {
                    href: "",
                    onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["prevent"])),
                    class: "text-body",
                    "data-toggle": "collapse",
                    "aria-expanded": "false"
                  }, _hoisted_89)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_90, [
            _createElementVNode("div", _hoisted_91, [
              (_ctx.getInterventionsAndContactsByUserId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getInterventionsAndContactsByUserId, (interventionsContactsByProject, projectId) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: projectId }, [
                        (_ctx.isUserAnAnsprechpartner(interventionsContactsByProject))
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "badge badge-pill cursor-pointer bg-primary mb-1 mr-1",
                              onClick: ($event: any) => (_ctx.navigateToAnsprechpartner(projectId))
                            }, _toDisplayString(projectId) + "; " + _toDisplayString(interventionsContactsByProject.p_firma ? interventionsContactsByProject.p_firma : interventionsContactsByProject.p_vorname +" "+ interventionsContactsByProject.p_name), 9, _hoisted_93))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_94, [
          _createElementVNode("div", _hoisted_95, [
            _createElementVNode("h6", _hoisted_96, [
              _createElementVNode("a", _hoisted_97, [
                _hoisted_98,
                _createElementVNode("div", _hoisted_99, [
                  _createElementVNode("a", {
                    href: "",
                    onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["prevent"])),
                    class: "text-body",
                    "data-toggle": "collapse",
                    "aria-expanded": "false"
                  }, _hoisted_101)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_102, [
              _createElementVNode("span", null, _toDisplayString(_ctx.user.street.value) + " " + _toDisplayString(_ctx.user.houseNumber.value), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.user.zipCode.value) + " " + _toDisplayString(_ctx.user.city.value), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_103, [
            _createElementVNode("div", _hoisted_104, [
              _createElementVNode("div", _hoisted_105, [
                _createElementVNode("label", _hoisted_106, _toDisplayString(_ctx.user.street.name), 1),
                _createElementVNode("div", _hoisted_107, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    required: "",
                    placeholder: _ctx.user.street.name,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.user.street.value) = $event))
                  }, null, 8, _hoisted_108), [
                    [_vModelText, _ctx.user.street.value]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_109, [
                _createElementVNode("label", _hoisted_110, _toDisplayString(_ctx.user.houseNumber.name), 1),
                _createElementVNode("div", _hoisted_111, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    required: "",
                    placeholder: _ctx.user.houseNumber.name,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.user.houseNumber.value) = $event))
                  }, null, 8, _hoisted_112), [
                    [_vModelText, _ctx.user.houseNumber.value]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_113, [
                _createElementVNode("label", _hoisted_114, _toDisplayString(_ctx.user.zipCode.name), 1),
                _createElementVNode("div", _hoisted_115, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    required: "",
                    placeholder: _ctx.user.zipCode.name,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.user.zipCode.value) = $event))
                  }, null, 8, _hoisted_116), [
                    [_vModelText, _ctx.user.zipCode.value]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_117, [
                _createElementVNode("label", _hoisted_118, _toDisplayString(_ctx.user.city.name), 1),
                _createElementVNode("div", _hoisted_119, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    required: "",
                    placeholder: _ctx.user.city.name,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.user.city.value) = $event))
                  }, null, 8, _hoisted_120), [
                    [_vModelText, _ctx.user.city.value]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_121, [
                _createElementVNode("label", _hoisted_122, _toDisplayString(_ctx.user.country.name), 1),
                _createElementVNode("div", _hoisted_123, [
                  _withDirectives(_createElementVNode("select", {
                    readonly: "readonly",
                    tabindex: "11",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.user.country.value) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: country.code
                      }, _toDisplayString(country.name), 9, _hoisted_124))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.user.country.value]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_125, [
                _createElementVNode("div", _hoisted_126, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.saveEmployee && _ctx.saveEmployee(...args))),
                    disabled: !_ctx.userRights.user?.write
                  }, "Stammdaten speichern", 8, _hoisted_127)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_128, [
          _createElementVNode("div", _hoisted_129, [
            _createElementVNode("h6", _hoisted_130, [
              _createElementVNode("a", _hoisted_131, [
                _hoisted_132,
                _createElementVNode("div", _hoisted_133, [
                  _createElementVNode("a", {
                    href: "",
                    onClick: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["prevent"])),
                    class: "text-body",
                    "data-toggle": "collapse",
                    "aria-expanded": "false"
                  }, _hoisted_135)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_136, [
            _createElementVNode("div", _hoisted_137, [
              _createElementVNode("div", _hoisted_138, [
                _createElementVNode("table", _hoisted_139, [
                  _hoisted_140,
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_141,
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_142, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            class: "custom-control-input",
                            id: "slc_arming_read",
                            checked: _ctx.user.rights.arming.write,
                            disabled: _ctx.user.status.value == '3',
                            onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.user.rights.arming.write = !_ctx.user.rights.arming.write))
                          }, null, 40, _hoisted_143),
                          _hoisted_144
                        ])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_145,
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_146, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            class: "custom-control-input",
                            id: "slc_company_read",
                            checked: _ctx.user.rights.company.write,
                            disabled: _ctx.user.status.value == '3',
                            onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.user.rights.company.write = !_ctx.user.rights.company.write))
                          }, null, 40, _hoisted_147),
                          _hoisted_148
                        ])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_149,
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_150, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            class: "custom-control-input",
                            id: "slc_user_read",
                            checked: _ctx.user.rights.user.read,
                            disabled: _ctx.user.status.value == '3',
                            onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.user.rights.user.read = !_ctx.user.rights.user.read))
                          }, null, 40, _hoisted_151),
                          _hoisted_152
                        ])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_153,
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_154, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            class: "custom-control-input",
                            id: "slc_user_write",
                            checked: _ctx.user.rights.user.write,
                            disabled: _ctx.user.status.value == '3',
                            onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.user.rights.user.write = !_ctx.user.rights.user.write))
                          }, null, 40, _hoisted_155),
                          _hoisted_156
                        ])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_157,
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_158, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            class: "custom-control-input",
                            id: "slc_bill_read",
                            checked: _ctx.user.rights.invoice.read,
                            disabled: _ctx.user.status.value == '3',
                            onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.user.rights.invoice.read = !_ctx.user.rights.invoice.read))
                          }, null, 40, _hoisted_159),
                          _hoisted_160
                        ])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_161,
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_162, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            class: "custom-control-input",
                            id: "slc_contracts_read",
                            checked: _ctx.user.rights.contracts.read,
                            disabled: _ctx.user.status.value == '3',
                            onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.user.rights.contracts.read = !_ctx.user.rights.contracts.read))
                          }, null, 40, _hoisted_163),
                          _hoisted_164
                        ])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_165,
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_166, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            class: "custom-control-input",
                            id: "slc_interventions_write",
                            checked: _ctx.user.rights.interventions.write,
                            disabled: _ctx.user.status.value == '3',
                            onChange: _cache[25] || (_cache[25] = ($event: any) => (_ctx.user.rights.interventions.write = !_ctx.user.rights.interventions.write))
                          }, null, 40, _hoisted_167),
                          _hoisted_168
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_169, [
                _createElementVNode("div", _hoisted_170, [
                  (_ctx.user.role != 10)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-primary",
                        onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.saveEmployee && _ctx.saveEmployee(...args))),
                        disabled: !_ctx.userRights.user?.write
                      }, "Rechte speichern", 8, _hoisted_171))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_172, [
          _createElementVNode("div", _hoisted_173, [
            _createElementVNode("h6", _hoisted_174, [
              _createElementVNode("a", _hoisted_175, [
                _hoisted_176,
                _createElementVNode("div", _hoisted_177, [
                  _createElementVNode("a", {
                    href: "",
                    onClick: _cache[27] || (_cache[27] = _withModifiers(() => {}, ["prevent"])),
                    class: "text-body",
                    "data-toggle": "collapse",
                    "aria-expanded": "false"
                  }, _hoisted_179)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_180, [
            _createElementVNode("div", _hoisted_181, [
              _createElementVNode("div", _hoisted_182, [
                _createElementVNode("table", _hoisted_183, [
                  _hoisted_184,
                  _createElementVNode("tbody", _hoisted_185, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_186, _toDisplayString(project.pid), 1),
                        _createElementVNode("td", null, _toDisplayString(project.p_firma), 1),
                        _createElementVNode("td", _hoisted_187, [
                          _createTextVNode(_toDisplayString(project.p_strasse) + " " + _toDisplayString(project.p_hnr) + " ", 1),
                          _hoisted_188,
                          _createTextVNode(" " + _toDisplayString(project.p_plz) + " " + _toDisplayString(project.p_ort), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_189, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              class: "custom-control-input",
                              id: 'custom-switch-'+index,
                              checked: _ctx.user.rights.projects.includes(project.pid),
                              disabled: _ctx.user.status.value == '3',
                              onChange: ($event: any) => (_ctx.onProjectRightChange($event, project.pid))
                            }, null, 40, _hoisted_190),
                            _createElementVNode("label", {
                              class: "custom-control-label",
                              for: 'custom-switch-'+index
                            }, null, 8, _hoisted_191)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_192, [
                _createElementVNode("div", _hoisted_193, [
                  (_ctx.user.role != 10)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-primary",
                        onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.saveEmployee && _ctx.saveEmployee(...args))),
                        disabled: !_ctx.userRights.user?.write
                      }, "Projektrechte speichern", 8, _hoisted_194))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}